import './bundle.scss';
import './app/_base.scss';

import LogUtil from './core/utils/logUtil';
import MainController from '@/app/controller/MainController';
import CoreApplication from './core/coreApplication';
import EventDispatcher from '@/core/event/eventDispatcher';
import ViewEvent from './core/event/viewEvent';
import ContentModel from './app/model/contentModel';
import ViewFactory from '@/app/views/viewFactory';
import AppStateModel from '@/app/model/appStateModel';
import NavigationBar from '@/app/components/navigation/navigationBar';
import { generateThemeCSS } from './core/utils/themeRuntimeCSS';
import HelperUtil from "@/core/utils/helperUtil";
import CoreApplicationStateModel from "@/core/model/CoreApplicationStateModel";
import JSONUtil from "@/core/utils/jsonUtil";
import JSONLoader from "@/core/loader/jsonLoader";
import { setDefaultSharingData } from '@/core/utils/sharingDataUtil'

declare const __CONFIG_BASE_URL__: string;


class Application extends CoreApplication {


    private navi?:NavigationBar

    override loadContent() {
        // overrides superfunction
        LogUtil.log('loadcontent');

        // Check for theme query parameter
        let jsonURL: null|string = null
        let themeParam = HelperUtil.getQueryString('t', null, true);
        if (themeParam === null) {
            // No valid theme parameter provided, log a vague error and don't load the app
            LogUtil.error('Application configuration error. Unable to initialize.');
            return;
        } else {
            // we expect param to contain a CMS route, such as `service/json/versicherer/186880`
            const base = (__CONFIG_BASE_URL__ || '').trim();

            if (base.length > 0) {
                // remote configs
                jsonURL = `${base}/${themeParam}`.replace(/\/+/g, '/');  // clean slashes BEFORE adding protocol
                jsonURL = `https://${jsonURL}`;
            } else {
                // local configs/assets
                jsonURL = `LOCALDEV/${themeParam}`.replace(/\/+/g, '/');
            }
        }

        LogUtil.log('Theme parameter found:', themeParam);
        LogUtil.log('load JSON:', jsonURL);

        const loadDataSuccessHandler = (result: any) => {
            // formatting/toplevel_key only needed for remote CMS json
            const formatted = JSONUtil.searchReplace(result, "&#10;", "\\n")  // we expect encoded linebreaks from MPI's CMS - this was the decided upon encoding
            const cms_toplevel_key = "localizationsAsMap"  // new wrapper from MPI's CMS

            CoreApplicationStateModel.content = JSONUtil.replaceBasePath(formatted[0][cms_toplevel_key]);
            CoreApplicationStateModel.themeParam = themeParam
            this.loadContentComplete();
        };

        const loadDataErrorHandler = () => {
            // Log a vague error message when the theme file can't be loaded
            LogUtil.error('Application data error. Unable to initialize.');
        };

        JSONLoader.loadAll([jsonURL]).then(loadDataSuccessHandler, loadDataErrorHandler);
    }


    loadContentComplete() {

        ContentModel.instance.setData(AppStateModel.content);

        // create and inject theme CSS (fonts, colors)
        generateThemeCSS(ContentModel.instance.getCommonData());
        setDefaultSharingData(ContentModel.instance.getShareData())


        let targetNode = document.getElementsByTagName('nav')[0];

        if (!this.navi) {
            // set the navigation
            const views = ContentModel.instance.getViews();
            this.navi = new NavigationBar(targetNode, views);
            new MainController(this.navi);
       }

        EventDispatcher.dispatchEvent(new ViewEvent(ViewEvent.LOAD, AppStateModel.startView));
    }

    isProductionMode(): boolean {
        const meta = document.querySelector('meta[name="build-mode"]');
        return meta ? meta.getAttribute('content') === 'production' : false;
    }

    prepareApp(viewFactory:ViewFactory) {

        super.prepareApp(viewFactory);

        LogUtil.enableLog = !this.isProductionMode();

        // check if url hash is a valid contentID (and split it out from potential URL query-string parameters)
        let hash = window.location.hash.substring(3).split('?');

        let contentID = hash[0];
        let paramsURL = hash[1];

        LogUtil.log('view   :', contentID);
        LogUtil.log('params :', paramsURL);


        if (contentID && viewFactory.checkViewExists(contentID)) {
            AppStateModel.startView = contentID;
        }
        else {
            AppStateModel.startView = viewFactory.getAllViews()[0];
        }


        if (paramsURL) {
            let canJumpToStep = AppStateModel.decodeStateQueryString(paramsURL);
            if (canJumpToStep) {
                AppStateModel.enableJumpToStepOnce();
            }
        }


    }

    constructor() {
        super();

        this.prepareApp(new ViewFactory());
        this.loadContent();

        //1024px, 880px, 750px und 550px
        AppStateModel.breakpoints = ['none', 'w550', 'w750', 'w880', 'w1024'];
    }
}

new Application();

